// extracted by mini-css-extract-plugin
module.exports = {"field":"userDetailStyles_field__32TiM"};